import React from 'react';
import Lottie from 'react-lottie';
import dragAnimation from '../../../assets/lottie/tutorial/help-animation-mouse-drag.json';
import './style.css';

const DEFAULT_DURATION_MS = 4000;
const DEFAULT_FADE_OUT_MS = 500;

function DragHintOverlay({
  onDismiss,
  durationMs = DEFAULT_DURATION_MS,
  fadeOutMs = DEFAULT_FADE_OUT_MS,
}) {
  const [isFadingOut, setIsFadingOut] = React.useState(false);

  React.useEffect(() => {
    const safeDuration = Math.max(0, durationMs);
    const safeFadeOut = Math.max(0, Math.min(fadeOutMs, safeDuration));
    const fadeStartDelay = Math.max(0, safeDuration - safeFadeOut);

    const fadeTimer = setTimeout(() => {
      setIsFadingOut(true);
    }, fadeStartDelay);

    const dismissTimer = setTimeout(() => {
      onDismiss?.();
    }, safeDuration);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(dismissTimer);
    };
  }, [onDismiss, durationMs, fadeOutMs]);

  return (
    <div
      className={`drag-hint-overlay${isFadingOut ? ' drag-hint-overlay--fade-out' : ''}`}
      style={{ '--drag-hint-fade-ms': `${fadeOutMs}ms` }}
      aria-live="polite"
    >
      <div className="drag-hint-overlay__content">
        <div className="drag-hint-overlay__animation">
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: dragAnimation,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid meet',
              },
            }}
            height={360}
            width={360}
          />
        </div>
        <p className="drag-hint-overlay__text">Click & Drag to Look Around</p>
      </div>
    </div>
  );
}

export default DragHintOverlay;
